import { AGENT_URLS, getAgentUrls } from 'api/config';
import $api from 'api/http';
import _ from 'lodash';

export default class AgentService {
    static async timeframe(data: {
        start: Date;
        end: Date;
        activities: Array<string>;
        companyId: string;
        agentId: string;
    }) {
        const params = _.omit(data, ['companyId', 'agentId']);
        return $api.post(getAgentUrls({ reqName: AGENT_URLS.timeframe, ...data }), params);
    }
    static async summary(data: { start: Date; end: Date; companyId: string; agentId: string }) {
        const params = _.omit(data, ['companyId', 'agentId']);
        return $api.post(getAgentUrls({ reqName: AGENT_URLS.summary, ...data }), params);
    }
    static async detailed(data: { start: Date; end: Date; companyId: string; agentId: string }) {
        const params = _.omit(data, ['companyId', 'agentId']);
        return $api.post(getAgentUrls({ reqName: AGENT_URLS.detailed, ...data }), params);
    }
}
